import React, { useContext, useEffect, useRef, useState } from "react";
import { Button, Checkbox, List, Tree, Typography } from "antd";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import InputAdornment from "@mui/material/InputAdornment";
import {
  getdashboardgrouplist,
  getdashboarlist,
} from "../../Restclient/datacollection";
import { useSelector,useDispatch } from "react-redux";
import CustomDropDown from "../CommonComponents/CustomDropDown";
import "../../cssfiles/homepage.css";
import { createplantview, getplantview } from "../../Restclient/datacollection";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { tr } from "date-fns/locale";
import DashboardTableView from "./DashboardTableView";
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import { updateplatjson } from "../../store/login_data";
import LK_Loading from "../../images/LK_Loading.gif";
var counter = 1;
export default function Plantviewcreationpage() {
  const logindetails = useSelector((state) => state.logindata.userdetails);
  const theme = useSelector((state) => state.themedata.theme);
  const optionTextColor = theme === "dark" ? "#FFFFFF" : "#1A1A1A";
  const optionMenuBg = theme === "dark" ? "#2B2B2B" : "#F5F5F5";
  const optionHoverBg = theme === "dark" ? "#3B4248" : "#E8E8E8";

  const dispatch = useDispatch();
  const [confopenflag, setConfopenflag] = useState(false);
  const [platview, setPlatview] = useState([]);
  const [nodename, setNodename] = useState("");
  const [selectedkey, setSelectedkey] = useState(0);
  const [gData, setGData] = useState([]);
  const [dashboardgroup, setDashboardgroup] = useState([]);
  const [selectedgroup, setSelectedgroup] = useState("");
  const [dashboardlist, setDashboarlist] = useState([]);
  const [selecteddlist, setSelecteddlist] = useState([]);
  const [alldlist, setAlldlist] = useState([]);
  const [adddashboardflag, setAdddashboardflag] = useState(false);
  const [currentdashboardlist, setCurrentdashboardlist] = useState();
  const [plantclickstate, setPlantclickstate] = useState("add");
  const [dilogdeleteflag, setDilogdeleteflag] = useState(false);
  const [deleteindex, setDeleteindex] = useState(0);
  const [openbackdrop, setOpenbackdrop] = useState(false);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState("");
  const [dialogsaveflag, setDialogsaveflag] = useState(false);
    const [selectedNodeKey, setSelectedNodeKey] = useState(null);
  const selectedprojectname = useSelector((state) => state.mainpagedata.selectedprojectname)
  const [selectedtreekey, setSelectedtreekey] = useState(null);
    const [dBlistFlag, setDbListFlag] = useState(false);
  const handleselectedtreeindex = (index) => {
    console.log("handleselectedtreeindex ", index);
    setSelectedkey(index);
    setAlldlist([]);
    setConfopenflag(true);
    setNodename("");
    setPlantclickstate("add");
  };


  const handleSelectedTreeView = (index, name, dgroup, dsubgroup) => {
    setSelectedkey(index);
    setNodename(name);
    var grouplist = [];
    for (let i = 0; i < dgroup.length; i++) {
      grouplist.push({
        group: dgroup[i],
        subgroup: dsubgroup[i],
      });
    }
    setAlldlist(grouplist);
    setDbListFlag(true);
    setPlantclickstate("view");
  };
  const dashboardgropcallbeack = (res) => {
    //console.log("dashboard grouplist ", res)
    var grouplist = [];
    for (let i = 0; i < res.dashboardgrouplist.length; i++) {
      grouplist.push(res.dashboardgrouplist[i]);
    }
    //console.log("grouplist ",grouplist)
    setDashboardgroup(grouplist);
  };
  var oldplantjson = [];
  const createoldplantjson = (oldjson, newjson) => {
    for (let i = 0; i < oldjson.length; i++) {
      const node = oldjson[i];
      if (node.children.length !== 0) {
        newjson.push({
          key: node.key,
          id: node.id,
          label: node.label,
          children: [],
          maindashboardlist: node.maindashboardlist,
          subdashboardlist: node.subdashboardlist,
          title: (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Typography>
                {" "}
                {node.label}
                
              </Typography>

            </div>
          ),
        });
        //console.log("nodename ",nodename)
        counter = counter > node.key ? counter : node.key;
        createoldplantjson(
          oldjson[i].children,
          newjson[newjson.length - 1].children
        );
      } else {
        newjson.push({
          key: node.key,
          id: node.id,
          label: node.label,
          children: [],
          maindashboardlist: node.maindashboardlist,
          subdashboardlist: node.subdashboardlist,
          title: (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Typography> {node.label} </Typography>
            </div>
          ),
        });
        counter = counter > node.key ? counter : node.key;
        //createplantjson(oldjson.children, newjson.children)
      }
    }
  };

  const plantviewnewcallback = (res) => {
    console.log("plantviewnewcallback plantviewnewcallback", res);  
    if (Array.isArray(res.plantview) && res.plantview.length) {
      oldplantjson = [];
      dispatch(updateplatjson(res.plantview));
    }
    setLoading(false);
  }
  const plantviewcallback = (res) => {
    if (res.plantview.length) {
      oldplantjson = [];
      createoldplantjson(res.plantview[0].Plantview, oldplantjson);
      //console.log("oldplantjson ",oldplantjson)
      setPlatview(oldplantjson);
    }
    setLoading(false);
  };


    
  useEffect(() => {
      setLoading(true);
      getplantview(
      logindetails.Organizationid,
      selectedprojectname,
      plantviewcallback
    );
    getdashboardgrouplist(
      logindetails.Organizationid,
      selectedprojectname,
      dashboardgropcallbeack
    );
  }, []);

  const onDragEnter = (info) => {
    console.log(info);
    // expandedKeys, set it when controlled is needed
    // setExpandedKeys(info.expandedKeys)
  };

  const onDrop = (info) => {
    console.log(info);
    const dropKey = info.node.key;
    const dragKey = info.dragNode.key;
    const dropPos = info.node.pos.split("-");
    const dropPosition =
      info.dropPosition - Number(dropPos[dropPos.length - 1]); // the drop position relative to the drop node, inside 0, top -1, bottom 1

    const loop = (data, key, callback) => {
      for (let i = 0; i < data.length; i++) {
        if (data[i].key === key) {
          return callback(data[i], i, data);
        }
        if (data[i].children) {
          loop(data[i].children, key, callback);
        }
      }
    };
    const data = [...gData];

    // Find dragObject
    let dragObj;
    loop(data, dragKey, (item, index, arr) => {
      arr.splice(index, 1);
      dragObj = item;
    });
    if (!info.dropToGap) {
      // Drop on the content
      loop(data, dropKey, (item) => {
        item.children = item.children || [];
        // where to insert. New item was inserted to the start of the array in this example, but can be anywhere
        item.children.unshift(dragObj);
      });
    } else {
      let ar = [];
      let i;
      loop(data, dropKey, (_item, index, arr) => {
        ar = arr;
        i = index;
      });
      if (dropPosition === -1) {
        // Drop on the top of the drop node
        ar.splice(i, 0, dragObj);
      } else {
        // Drop on the bottom of the drop node
        ar.splice(i + 1, 0, dragObj);
      }
    }
    setGData(data);
  };

  const handleDbListClose = () => {
    setDbListFlag(false);
  };
  const handleaddnewplantview = () => {
    setConfopenflag(true);
    setNodename("");
    setAlldlist([]);
    setPlantclickstate("add");
  };

  const handledelenode = (index) => {
 
    setDeleteindex(index);
    setDilogdeleteflag(true);

  };

  const handleDbListSave = () => {

    const updatedTree = [...platview];
    updateNodeInTree(selectedkey, updatedTree, alldlist);

    setPlatview(updatedTree);
    setAlldlist(alldlist);
    setDbListFlag(false); 
 
  };

  const handleChangeDListView = (newDList) => {
    setAlldlist(newDList);
  };

  const updateNodeInTree = (key, tree, updatedDList) => {
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i];
      if (node.key === key) {
        // Update the node's dashboard lists
        node.maindashboardlist = updatedDList.map((item) => item.group);
        node.subdashboardlist = updatedDList.map((item) => item.subgroup);
        return;
      } else if (node.children && node.children.length > 0) {
        // Recursively search in the children
        updateNodeInTree(key, node.children, updatedDList);
      }
    }
  };



  const handleaddtreeelemrnt = () => {
  
    if (nodename === "" || nodename === undefined) {
      setMsg("Please enter node name");
      setDialogsaveflag(true);
      return;
    }

    var oldtree = [...platview];
    console.log("oldtree ", oldtree, nodename, plantclickstate);

    var dgroup = [];
    var dsubgroup = [];
    for (let i = 0; i < alldlist.length; i++) {
      dgroup.push(alldlist[i].group);
      dsubgroup.push(alldlist[i].subgroup);
    }
    if (plantclickstate === "add") {
      if (oldtree.length === 0) {
        var index = counter + 1;
        oldtree.push({
          title: (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Typography> {nodename} </Typography>
            </div>
          ),
          key: index,
          id: index,
          label: nodename,
          children: [],
          maindashboardlist: dgroup,
          subdashboardlist: dsubgroup,
        });
        counter = counter + 1;
      } else {
        //console.log("selectedkey ",selectedkey)
        updatetreejson(selectedkey, oldtree);
        counter = counter + 1;
      }

      setPlatview(oldtree);
    } else if (plantclickstate === "edit") {
      console.log("selectedkey ", selectedkey);
      updatetreeindex(selectedkey, oldtree);
      console.log("oldtree ", oldtree);
      setPlatview(oldtree);
    }
    handlesaveplantview()
    setConfopenflag(false);
  };

  const updatetreejson = (key, treejson) => {
    var dgroup = [];
    var dsubgroup = [];
    for (let i = 0; i < alldlist.length; i++) {
      dgroup.push(alldlist[i].group);
      dsubgroup.push(alldlist[i].subgroup);
    }

    for (let i = 0; i < treejson.length; i++) {
      const node = treejson[i];
      if (node.children.length !== 0) {
        if (node.key === key) {
          console.log("add node ", counter);

          var index = counter + 1;
          node.children.push({
            title: (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <Typography> {nodename} </Typography>
              </div>
            ),
            key: index,
            id: index,
            label: nodename,
            children: [],
            maindashboardlist: dgroup,
            subdashboardlist: dsubgroup,
          });
          counter = counter + 1;
          return;
        } else {
          updatetreejson(key, node.children);
        }
      } else {
        if (node.key === key) {
          var index = counter + 1;
          node.children.push({
            title: (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <Typography> {nodename} </Typography>
              </div>
            ),
            key: index,
            id: index,
            label: nodename,
            children: [],
            maindashboardlist: dgroup,
            subdashboardlist: dsubgroup,
          });
          counter = counter + 1;
          return;
        }
      }
    }
  };

  const updatetreeindex = (key, treejson) => {
    // console.log("updatetreeindex ",key, treejson)
    for (let i = 0; i < treejson.length; i++) {
      var node = treejson[i];
      if (node.key === key) {
        var dgroup = [];
        var dsubgroup = [];
        for (let i = 0; i < alldlist.length; i++) {
          dgroup.push(alldlist[i].group);
          dsubgroup.push(alldlist[i].subgroup);
        }
        node.title = (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <Typography> {nodename} </Typography>
           
          </div>
        );
        node.label = nodename;
        node.maindashboardlist = dgroup;
        node.subdashboardlist = dsubgroup;
        console.log("node ", node);
        return;
      } else {
        updatetreeindex(key, node.children);
      }
    }
  };

  const deleteelementtreejson = (key, treejson) => {
    //console.log("treejson", treejson)
    for (let i = 0; i < treejson.length; i++) {
      var node = treejson[i];
      //console.log("node.key ", node.key, key)
      if (node.key === key) {
        // console.log("found ", key)
        treejson.splice(i, 1);
        return;
      } else {
        deleteelementtreejson(key, node.children);
      }
    }
  };

  const handlecloseconfig = () => {
    setConfopenflag(false);
  };

  const handlechnagenodename = (e) => {
    setNodename(e.target.value);
  };

  const handleselectednode = (index, name, dgroup, dsubgroup) => {
    console.log("Selected ", index, name, dgroup, dsubgroup);
    setSelectedkey(index);
    setNodename(name);

    var grouplist = [];
    for (let i = 0; i < dgroup.length; i++) {
      grouplist.push({
        group: dgroup[i],
        subgroup: dsubgroup[i],
      });
    }
    setAlldlist(grouplist);
    setConfopenflag(true);
    setPlantclickstate("edit");
    
  };

  const callbackdashbordlist = (res) => {
    console.log("dashboard list ", res);
    var dlist = [];
    setCurrentdashboardlist(res.dashboardlist);
    for (let i = 0; i < res.dashboardlist.length; i++) {
      dlist.push({
        label: <span style={{ fontSize: 16, color: optionTextColor }}>{res.dashboardlist[i].Dashboardname}</span>,
        value: res.dashboardlist[i].Dashboardname,
      });
    }
    setDashboarlist(dlist);
  };

  const handleselectgroupname = (e) => {
    console.log("selecteddata ", e);
    var selectedgroupid = "";
    for (let i = 0; i < dashboardgroup.length; i++) {
      if (e.target.value === dashboardgroup[i].groupname) {
        selectedgroupid = dashboardgroup[i].groupid;
      }
    }

    setSelectedgroup({
      groupid: selectedgroupid,
      groupname: e.target.value,
      label: e.target.value,
      pagename: e.target.value,
    });
    if (selectedgroupid !== "") {
      getdashboarlist(
        logindetails.Organizationid,
        selectedprojectname,
        selectedgroupid,
        callbackdashbordlist
      );
    }
  };


  useEffect(() => {
    // Pre-select values for selecteddlist based on the selected group
    console.log("alldlist ", alldlist);
    console.log("selectedgroup.groupname ", selectedgroup.groupname);
  
    // Filter `alldlist` to find the selected group and its subgroups
    const preSelectedValues = alldlist
      .filter((item) => item.group.groupname === selectedgroup.groupname) // Match the selected group
      .flatMap((item) => Array.isArray(item.subgroup) && item.subgroup.length > 0 ? item.subgroup.map((sub) => sub.Dashboardname) : [] ); // Extract Dashboardname
  
    setSelecteddlist(preSelectedValues); // Update the selecteddlist state
  }, [selectedgroup.groupname, alldlist]);

  const handledashboardlistselect = (checkedValues) => {
    setSelecteddlist(checkedValues);
    console.log("Selected Dashboard List: ", checkedValues);
  };



  const handleadddashboard = () => {
    console.log("mainlist", alldlist, selecteddlist);
    var mainlist = [...alldlist];
    var groupExists = false;

    for (let i = 0; i < mainlist.length; i++) {
      if (mainlist[i].group.groupname === selectedgroup.groupname) {
        // Update the existing group with the new subgroups
        var updatedSubgroup = [];
        for (let j = 0; j < selecteddlist.length; j++) {
          for (let k = 0; k < currentdashboardlist.length; k++) {
            if (currentdashboardlist[k].Dashboardname === selecteddlist[j]) {
              console.log("currentdashboardlist[k] ", currentdashboardlist[k]);
              var jsonobj = {
                Dashboardname: currentdashboardlist[k].Dashboardname,
                dashboard_pro: currentdashboardlist[k].dashboard_pro,
                label: currentdashboardlist[k].Dashboardname,
                pagename: currentdashboardlist[k].Dashboardname,
              };
              updatedSubgroup.push(jsonobj);
              break;
            }
          }
        }
        mainlist[i].subgroup = updatedSubgroup;
        groupExists = true;
        break;
      }
    }

    if (!groupExists) {
      // Add new group with subgroups
      var dlist = [];
      for (let j = 0; j < selecteddlist.length; j++) {
        for (let k = 0; k < currentdashboardlist.length; k++) {
          if (currentdashboardlist[k].Dashboardname === selecteddlist[j]) {
            console.log("currentdashboardlist[k] ", currentdashboardlist[k]);
            var jsonobj = {
              Dashboardname: currentdashboardlist[k].Dashboardname,
              dashboard_pro: currentdashboardlist[k].dashboard_pro,
              label: currentdashboardlist[k].Dashboardname,
              pagename: currentdashboardlist[k].Dashboardname,
            };
            dlist.push(jsonobj);
            break;
          }
        }
      }

      mainlist.push({
        group: selectedgroup,
        subgroup: dlist,
      });
    }

    setAlldlist(mainlist);
    setAdddashboardflag(false);
    console.log("mainlist ", mainlist);
    //setNodename("")
    //setDashboardgroup([])
    //setDashboarlist([])
  };

  const handlecloseadddashboard = () => {
    setAdddashboardflag(false);
    //setNodename("")
    //setDashboardgroup([])
    //setDashboarlist([])
  };

  const handledeletelistitem = (data) => {
    console.log("item to delete", data);
    var mainlist = [...alldlist];
    var newlist = mainlist.filter((item) => item.group.groupname !== data);
    console.log("newlist ", newlist);
    setAlldlist(newlist);
  };

  const handledashboardadd = () => {
    if (!adddashboardflag) {
      setAdddashboardflag(true);
    }
  };

  var plantfinaljson = [];
  const createplantjson = (oldjson, newjson) => {
    for (let i = 0; i < oldjson.length; i++) {
      const node = oldjson[i];
      if (node.children.length !== 0) {
        newjson.push({
          key: node.key,
          id: node.id,
          label: node.label,
          children: [],
          maindashboardlist: node.maindashboardlist,
          subdashboardlist: node.subdashboardlist,
        });
        console.log("nodename ", nodename);
        createplantjson(
          oldjson[i].children,
          newjson[newjson.length - 1].children
        );
      } else {
        newjson.push({
          key: node.key,
          id: node.id,
          label: node.label,
          children: [],
          maindashboardlist: node.maindashboardlist,
          subdashboardlist: node.subdashboardlist,
        });
        //createplantjson(oldjson.children, newjson.children)
      }
    }
  };

  const createplantviewstatus = (res) => {

    setOpenbackdrop(false);
    if (res.status === "done") {
      setMsg("Creation/Update of plantview completed");
      setDialogsaveflag(true);
    } else {
      setMsg("Error in Creation/Update of plantview");
      setDialogsaveflag(true);
    }
  };

  const handlesaveplantview = (sourceTree, createIfEmpty = true) => {
    setOpenbackdrop(true);
    const plantfinaljson = [];

    // Determine source tree: prefer explicit arg, else current state, else build minimal root
    let treeToSerialize = Array.isArray(sourceTree) ? sourceTree : platview;
    if ((!treeToSerialize || treeToSerialize.length === 0) && createIfEmpty) {
      const index = counter + 1;
      const dgroup = [];
      const dsubgroup = [];
      for (let i = 0; i < alldlist.length; i++) {
        dgroup.push(alldlist[i].group);
        dsubgroup.push(alldlist[i].subgroup);
      }
      treeToSerialize = [{
        key: index,
        id: index,
        label: nodename && nodename.trim() !== "" ? nodename : "Root",
        children: [],
        maindashboardlist: dgroup,
        subdashboardlist: dsubgroup,
      }];
      // Reflect in state but do not depend on state for serialization
      setPlatview(treeToSerialize);
      counter = index;
    } else if (!treeToSerialize || treeToSerialize.length === 0) {
      // keep empty payload when not creating root (e.g., after deleting all nodes)
      treeToSerialize = [];
      setPlatview([]);
    }

    // Create the plant JSON structure from the determined tree
    createplantjson(treeToSerialize, plantfinaljson);
  
    // Save the plant view
    createplantview(
      logindetails.Organizationid,
      selectedprojectname,
      plantfinaljson,
      (res) => {
        createplantviewstatus(res); // Handle the response status
  
        if (res.status === "done") {
          // Update the tree with the saved data to trigger a re-render
          const updatedTree = [];
          createoldplantjson(plantfinaljson, updatedTree); // Recreate the tree structure
          setPlatview([...updatedTree]); // Update the state with a new reference
            // Add a short delay before fetching the latest plantview from backend
            setTimeout(() => {
              setLoading(true);
              getplantview(
                logindetails.Organizationid,
                selectedprojectname,
                plantviewnewcallback
              );
            }, 4000); // 400ms delay

        }
  
        setOpenbackdrop(false); // Close the backdrop
      }
    );
  

    setSelectedNodeKey(null);
    setSelectedgroup({});
    setSelecteddlist([]);
    setDashboarlist([]);  
    setAdddashboardflag(false); 
    
  };

  const handleClosedialogdelete = () => {
    setDilogdeleteflag(false);
  };

  const handledelettreeindex = () => {
    var oldtree = [...platview];
    deleteelementtreejson(deleteindex, oldtree);
    setPlatview(oldtree);
    setDilogdeleteflag(false);
    // Save using the freshly updated tree without auto-creating root
    handlesaveplantview(oldtree, false)
    setSelectedNodeKey(null);
    setSelectedtreekey(null);
  };

  const handleCloseBackdrop = () => {
    setOpenbackdrop(false);
  };

  const handleClosedialogsave = () => {
    setDialogsaveflag(false);
  };

  return (
    <div
      style={{
        margin: "10px",
        height: "calc(100% - 20px)",
        display: "flex",
        flexDirection: "row",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          textAlign: "left",
          backgroundColor: "var(--PrimaryBackground)",
        }}
      >
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            position: "absolute",
            width: "100%",
            height: "100%",
          }}
          open={openbackdrop}
          onClick={handleCloseBackdrop}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        {loading ? (
          <div
            style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={LK_Loading}
              alt="loading..."
              style={{ height: "15%", width: "15%", alignSelf: "center" }}
            />
          </div>
        ) : platview.length > 0 ? (
          <>
            <div style={{ display: "flex", margin: "10px 20px 20px 20px" }}>
              <div style={{ flexGrow: 1 }}></div>
            </div>
            <div
              style={{
                overflow: "auto",
                height: "calc(100% - 70px)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {selectedNodeKey !== null && (
                  <>
                    <Button
                      type="link"
                      icon={
                        <EyeOutlined
                          style={{
                            color: "var(--LK_BrandBlue)",
                            padding: "0px 0px",
                          }}
                        />
                      }
                      onClick={() =>
                        handleSelectedTreeView(
                          selectedNodeKey.key,
                          selectedNodeKey.label,
                          selectedNodeKey.maindashboardlist,
                          selectedNodeKey.subdashboardlist
                        )
                      }
                    >
                      {" "}
                      view
                    </Button>
                    <Button
                      type="link"
                      icon={
                        <PlusOutlined
                          style={{
                            color: "var(--LK_BrandBlue)",
                            padding: "0px 0px",
                          }}
                        />
                      }
                      onClick={() => handleselectedtreeindex(selectedNodeKey.key)}
                    >
                      {" "}
                      Add
                    </Button>
                    <Button
                      type="link"
                      icon={
                        <EditOutlined
                          style={{
                            color: "var(--LK_BrandBlue)",
                            padding: "0px 0px",
                          }}
                        />
                      }
                      onClick={() =>
                        handleselectednode(
                          selectedNodeKey.key,
                          selectedNodeKey.label,
                          selectedNodeKey.maindashboardlist,
                          selectedNodeKey.subdashboardlist
                        )
                      }
                    >
                      {" "}
                      Edit
                    </Button>
                    <Button
                      type="link"
                      icon={
                        <DeleteOutlined
                          style={{
                            color: "var(--LK_BrandBlue)",
                            padding: "0px 0px",
                          }}
                        />
                      }
                      onClick={() => handledelenode(selectedNodeKey.key)}
                    >
                      {" "}
                      Delete
                    </Button>
                  </>
                )}
              </div>
              <Tree
                draggable
                blockNode
                onDragEnter={onDragEnter}
                onDrop={onDrop}
                treeData={platview}
                className={`antdtree ${theme === "dark" ? "antdtree-dark" : "antdtree-light"}`}
                selectedKeys={selectedtreekey !== null ? [selectedtreekey] : []}
                onSelect={(selectedKeys, e) => {
                  if (selectedKeys.length > 0) {
                    setSelectedNodeKey(e.node);
                    setSelectedtreekey(selectedKeys[0]);
                    console.log("Selected Node:", e.node);
                  } else {
                    setSelectedNodeKey(null);
                    setSelectedtreekey(null);
                    console.log("No Node Selected");
                  }
                }}
              />
            </div>
          </>
        ) : (
          <div style={{ display: "flex", margin: "10px 20px 20px 20px" }}>
            <Typography
              style={{
                fontSize: "16px",
                fontWeight: 400,
                marginRight: "10px",
                color: "var(--PrimaryText)",
              }}
            >
              {" "}
              Create plant View for the project{" "}
            </Typography>
            <button
              style={{
                padding: "8px 20px",
                backgroundColor: "var(--LK_BrandBlue)",
                color: "var(--White)",
                border: "none",
                borderRadius: "20px",
                fontSize: "16px",
                fontWeight: 700,
                fontFamily: "Roboto",
                cursor: "pointer",
              }}
              onClick={handleaddnewplantview}
            >
              Create New Plantview
            </button>
          </div>
        )}
        <CustomDialogBox
          dialogTitle={"Conformation Info"}
          dialogText={"Do you want to delete ?"}
          openDialog={dilogdeleteflag}
          handleConfirmDialog={handledelettreeindex}
          confirmText={"Delete"}
          cancelText={"Close"}
          type={"Warning"}
          align={"left"}
          handleCloseDialog={handleClosedialogdelete}
        />

        <CustomDialogBox
          dialogTitle={"Dashboard list"}
          openDialog={dBlistFlag}
          handleCloseDialog={handleDbListClose}
          type={"Info"}
          maxWidth={"lg"}
          align={"left"}
        >
          <div
            style={{
              // backgroundColor: theme === "dark" ? "#000000" : "#EFEFEF",
              color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
              padding: "8px",
            }}
          >
            <Typography style={{ color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",pb:1 }}>
              Selected Node : {nodename}
            </Typography>

            <DashboardTableView
              nodeData={alldlist}
              onChange={handleChangeDListView}
              plantclickstate={plantclickstate}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "16px 0 0 0",
              }}
            >
              {plantclickstate === "view" ? (
                <button
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "transparent",
                    color: theme === "dark" ? "#FFFFFF" : "#7E7E7E",
                    border: "1px solid",
                    borderColor: theme === "dark" ? "#7E7E7E" : "#7E7E7E",
                    borderRadius: "20px",
                    fontSize: "16px",
                    fontWeight: 700,
                    fontFamily: "Roboto",
                    cursor: "pointer",
                    marginRight: "10px",
                    transition: "all 0.3s ease",
                  }}
                  onClick={handleDbListClose}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor =
                      theme === "dark" ? "#333333" : "#F5F5F5")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor = "transparent")
                  }
                >
                  Close
                </button>
              ) : (
                <>
                  <button
                    style={{
                      padding: "8px 20px",
                      backgroundColor: "transparent",
                      color: theme === "dark" ? "#FFFFFF" : "#7E7E7E",
                      border: "1px solid",
                      borderColor: theme === "dark" ? "#7E7E7E" : "#7E7E7E",
                      borderRadius: "20px",
                      fontSize: "16px",
                      fontWeight: 700,
                      fontFamily: "Roboto",
                      cursor: "pointer",
                      marginRight: "10px",
                      transition: "all 0.3s ease",
                    }}
                    onClick={handleDbListClose}
                    onMouseEnter={(e) =>
                      (e.target.style.backgroundColor =
                        theme === "dark" ? "#333333" : "#F5F5F5")
                    }
                    onMouseLeave={(e) =>
                      (e.target.style.backgroundColor = "transparent")
                    }
                  >
                    Cancel
                  </button>
                  <button
                    style={{
                      padding: "8px 20px",
                      backgroundColor: "#005C8E",
                      color: "#FFFFFF",
                      border: "none",
                      borderRadius: "20px",
                      fontSize: "16px",
                      fontWeight: 700,
                      fontFamily: "Roboto",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                    }}
                    onClick={handleDbListSave}
                    onMouseEnter={(e) =>
                      (e.target.style.backgroundColor = "#004A70")
                    }
                    onMouseLeave={(e) =>
                      (e.target.style.backgroundColor = "#005C8E")
                    }
                  >
                    Save
                  </button>
                </>
              )}
            </div>
          </div>
        </CustomDialogBox>

        <CustomDialogBox
          dialogTitle={"Conformation Info"}
          dialogText={msg}
          openDialog={dialogsaveflag}
          handleConfirmDialog={handleClosedialogsave}
          confirmText={"Close"}
          type={"Info"}
          align={"left"}
        />
      </div>

      <CustomDialogBox
        dialogTitle={plantclickstate === "edit" ? "Edit Node" : "Add Node"}
        openDialog={confopenflag}
        handleCloseDialog={handlecloseconfig}
        type={"Info"}
        maxWidth={"md"}
        align={"left"}
      >
          <div style={{ overflow: "auto", height: "100%" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                height: "50px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginRight: "20px",
                  marginTop: "10px",
                  width: "100%",
                  marginBottom: "20px",
                }}
              >
                <div style={{ flexGrow: 1 }}></div>
                <button
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "transparent",
                    color: theme === "dark" ? "#FFFFFF" : "#7E7E7E",
                    border: "1px solid",
                    borderColor: theme === "dark" ? "#7E7E7E" : "#7E7E7E",
                    borderRadius: "20px",
                    fontSize: "16px",
                    fontWeight: 700,
                    fontFamily: "Roboto",
                    cursor: "pointer",
                    marginRight: "10px",
                    transition: "all 0.3s ease",
                  }}
                  onClick={handlecloseconfig}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor =
                      theme === "dark" ? "#333333" : "#F5F5F5")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor = "transparent")
                  }
                >
                  Close
                </button>
                <button
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#005C8E",
                    color: "#FFFFFF",
                    border: "none",
                    borderRadius: "20px",
                    fontSize: "16px",
                    fontWeight: 700,
                    fontFamily: "Roboto",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                  onClick={handleaddtreeelemrnt}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "#004A70")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor = "#005C8E")
                  }
                >
                  Save
                </button>
              </div>
            </div>
            <div
              style={{
                height: "calc(100% - 50px)",
                overflow: "auto",
              }}
            >
              <div
                style={{
                  /*border: '1px solid', borderColor: 'var(--LK_BrandBlue)',*/ 
                  backgroundColor:"var(--SecondaryBackground)",
                  marginBottom: "10px",
                  // margin: '10px',
                  padding: "10px",
                }}
              >
                <div style={{ display: "flex", width: "300px" }}>
                  <TextField
                    id="Longitude"
                    label={
                      <Typography
                        style={{
                          fontSize: 20,
                          fontWeight: 500,
                          color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
                        }}
                      >
                        {" "}
                        Node Name {" "}
                      </Typography>
                    }
                    variant="standard"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      ),
                      style: {
                        color: "var(--PrimaryText)",
                      },
                    }}
                    sx={{
                      width: "300px",
                      "& .MuiInput-underline:before": {
                        borderBottomColor: "var(--PrimaryText)",
                      },
                    }}
                    value={nodename}
                    onChange={handlechnagenodename}
                  />
                </div>
              </div>
              <div
                style={{
                  backgroundColor: theme === "dark" ? "#2b2b2b" : "#EFEFEF",
                  padding: "10px"
                }}
              >
                {!adddashboardflag && (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      marginBottom: "10px",
                    }}
                  >
                    <div style={{ flexGrow: 1 }}></div>
                    <button
                      style={{
                        padding: "8px 20px",
                        backgroundColor: "#005C8E",
                        color: "#FFFFFF",
                        border: "none",
                        borderRadius: "20px",
                        fontSize: "16px",
                        fontWeight: 700,
                        fontFamily: "Roboto",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.backgroundColor = "#004A70")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.backgroundColor = "#005C8E")
                      }
                      onClick={handledashboardadd}
                    >
                      Add Dashboard
                    </button>
                  </div>
                )}
                {adddashboardflag && (
                  <div
                    style={
                      {
                        /*border: '1px solid', borderColor: 'var(--LK_BrandBlue)',*/
                        // width: '96%', marginBottom: '20px', marginTop: '10px'
                      }
                    }
                  >
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        marginTop: "20px",
                      }}
                    >
                      <div style={{ flexGrow: 1 }}></div>
                      <button
                        style={{
                          padding: "8px 20px",
                          backgroundColor: "transparent",
                          color: theme === "dark" ? "#FFFFFF" : "#7E7E7E",
                          border: "1px solid",
                          borderColor: theme === "dark" ? "#7E7E7E" : "#7E7E7E",
                          borderRadius: "20px",
                          fontSize: "16px",
                          fontWeight: 700,
                          fontFamily: "Roboto",
                          cursor: "pointer",
                          marginRight: "10px",
                          transition: "all 0.3s ease",
                        }}
                        onClick={handlecloseadddashboard}
                        onMouseEnter={(e) =>
                          (e.target.style.backgroundColor =
                            theme === "dark" ? "#333333" : "#F5F5F5")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.backgroundColor = "transparent")
                        }
                      >
                        Cancel
                      </button>
                      <button
                        style={{
                          padding: "8px 20px",
                          backgroundColor: "#005C8E",
                          color: "#FFFFFF",
                          border: "none",
                          borderRadius: "20px",
                          fontSize: "16px",
                          fontWeight: 700,
                          fontFamily: "Roboto",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                        }}
                        onClick={handleadddashboard}
                        onMouseEnter={(e) =>
                          (e.target.style.backgroundColor = "#004A70")
                        }
                        onMouseLeave={(e) =>
                          (e.target.style.backgroundColor = "#005C8E")
                        }
                      >
                        Add
                      </button>
                    </div>
                    <div
                      style={{
                        marginBottom: "20px",
                      }}
                    >
                      <FormControl
                        variant="standard"
                        sx={{
                          m: 1,
                          minWidth: 120,
                          width: "300px",
                          margin: "20px",
                          "& .MuiInputLabel-root": {
                            color: optionTextColor,
                          },
                        }}
                      >
                        <InputLabel id="demo-simple-select-standard-label">
                          {" "}
                          Group List
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-standard-label"
                          id="demo-simple-select-standard"
                          value={selectedgroup.groupname}
                          onChange={handleselectgroupname}
                          label="Group List"
                          style={{
                            textAlign: "left",
                            paddingBottom: "0px",
                            paddingTop: "0px",
                            color: optionTextColor,
                          }}
                          sx={{
                            border: 0,
                            width: "224px",
                            //height: '24px',
                            margingBottom: "10px",
                            bgcolor: "var(--SecondaryBackground)",
                            color: optionTextColor,
                            fontSize: "18px",
                            fontFamily: "Roboto",
                            fontWeight: 400,
                            textAlign: "left",
                            borderRadius: 0,
                            marginRight: "0px",
                            "& .MuiOutlinedInput-underline:before": {
                              borderBottomColor: "var(--PrimaryText)",
                            },
                            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                border: 0,
                              },
                            "& .MuiOutlinedInput-notchedOutline ": {
                              width: "122.35px",
                              //height:'24px',
                              border: 0,
                              padding: 0,
                            },
                            "& .MuiInputLabel-root": {
                              display: "none",
                              legend: "none",
                            },
                            "& .MuiSelect-select": {
                              paddingTop: "0px",
                              paddingBottom: "0px",
                            },
                          }}
                          InputLabelProps={{ shrink: false }}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                bgcolor: optionMenuBg,
                                borderBottom: "2px solid #008CD7",
                                borderRadius: 0,
                                boxShadow: "none",
                                maxHeight: "250px",
                                overflow: "auto",
                                color: optionTextColor,
                                "& .MuiMenuItem-root": {
                                  color: optionTextColor,
                                },
                                "& .MuiMenuItem-root:hover": {
                                  backgroundColor: optionHoverBg,
                                },
                                "& .MuiMenuItem-root.Mui-selected": {
                                  backgroundColor: optionHoverBg,
                                  color: optionTextColor,
                                },
                                "& .MuiMenuItem-root.Mui-selected:hover": {
                                  backgroundColor: optionHoverBg,
                                },
                              },
                            },
                          }}
                        >
                        
                          {Array.isArray(dashboardgroup) ? dashboardgroup.map((name) => {
                            return (
                              <MenuItem
                                sx={{
                                  fontSize: "16px",
                                  fontFamily: "Roboto",
                                  fontWeight: 400,
                                  color: optionTextColor,
                                  "&:hover": {
                                    backgroundColor: optionHoverBg,
                                  },
                                }}
                                value={name.groupname}
                              >
                                {name.groupname}
                              </MenuItem>
                            );
                          }) : null}
                        </Select>
                      </FormControl>
                    </div>
                    <div>
                      <Checkbox.Group
                        options={dashboardlist}
                        onChange={handledashboardlistselect}
                        value={selecteddlist}
                        className={`plantview-dashboard-checkbox-group ${theme === "dark" ? "dark" : "light"}`}
                        style={{
                          margin: "20px",
                          fontSize: "18px",
                          fontWeight: 400,
                          display: "grid",
                          color: optionTextColor,
                        }}
                      />
                    </div>
                  </div>
                )}
               {!adddashboardflag && <div
                  style={{
                    /*border: '1px solid', borderColor: 'var(--LK_BrandBlue)',*/ 
                    width: "96%",
                    marginBottom: "20px",
                  }}
                >
                  <div
                    style={{
                      // margin: '20px',
                      textAlign: "left",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: 16,
                        fontWeight: 500,
                        color: "var(--PrimaryText)",
                      }}
                    >
                      {" "}
                      Dashboard List {" "}
                    </Typography>
                    <br />
                  <DashboardTableView
                      nodeData={alldlist}
                      handleClose={handleDbListClose}
                      onChange={handleChangeDListView}
                      plantclickstate={plantclickstate}
                    />
                  </div>
                </div>}
              </div>
            </div>
          </div>
      </CustomDialogBox>
      {/* //   }
      // </div> */}
    </div>
  );
}
